import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import Paper from '@material-ui/core/Paper';
import './TalonRegistrationTranslate';
import {
  talonRegistrationModule,
  loadDetail,
  registerCoupon,
  clearState
} from './TalonRegistrationDucks';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import PageLoading from '../../components/PageLoader/PageLoading';
import Row from '../../_ui/Row';
import Button from '../../_ui/Button/Button';
import { history } from '../../_helpers/history';
import paths from '../../_helpers/paths';
import { Color } from '../../components/ThemeProvider/ThemeStyle';

export default function TalonRegistrationViewPage() {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { detail, loadingDetail, registeringId } = useSelector(
    state => state[talonRegistrationModule]
  );

  const breadCrumbItems = [
    { name: i18next.t('breadcrumbs_home'), href: '/' },
    {
      name: i18next.t('breadcrumbs_talonRegistration'),
      href: paths.talonRegistrationPage
    },
    { name: i18next.t('breadcrumbs_talonRegistrationView') }
  ];

  useEffect(() => {
    if (id) {
      dispatch(loadDetail(id));
    }
    return () => dispatch(clearState());
  }, [dispatch, id]);

  return (
    <PageLoading loading={loadingDetail}>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper className="pb3 pt1 px3">
        <h3>{t('talonRegistration_viewTitle')}</h3>
        <div className="col-8">
          <Row label={t('talonRegistration_columnId')}>{detail.serviceProviderId}</Row>
          <Row label={t('talonRegistration_columnName')}>
            {detail[`serviceProvider${i18n.language === 'kk' ? 'Kk' : 'Ru'}Name`] || ''}
          </Row>
          <Row label={t('talonRegistration_columnBin')}>{detail.serviceProviderBin}</Row>
          <Row label={t('talonRegistration_columnLocality')}>
            {detail.serviceProviderLegalLocalityName
              ? detail.serviceProviderLegalLocalityName[`${i18n.language}_name`]
              : ''}
          </Row>
          <Row label={t('talonRegistration_columnLegalAddress')}>
            {detail.legalAddress}
          </Row>
          <Row label={t('talonRegistration_columnDesignCapacity')}>
            {detail.designCapacity}
          </Row>
          <Row label={t('talonRegistration_columnIsActive')}>
            {detail.couponId
              ? t('talonRegistration_registered')
              : detail.isActive
              ? t('talonRegistration_active')
              : t('talonRegistration_inactive')}
          </Row>
        </div>
        {detail.isActive && !detail.couponId && (
          <div className="mt3">
            <Button
              size="small"
              style={{ backgroundColor: Color.bgColorSuccess }}
              text={t('talonRegistration_register')}
              loading={registeringId === detail.id}
              onClick={() =>
                dispatch(
                  registerCoupon(detail.id, () =>
                    history.push(paths.talonRegistrationPage)
                  )
                )
              }
            />
          </div>
        )}
      </Paper>
    </PageLoading>
  );
}
